import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AllItems from "../components/Views/AllItems.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import Container from "./Container.jsx";
import {refund} from "../datasource/schema";

class RefundContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("refund");
        this.state = {
            ...this.state,
            loading: true,
            getParams: { ...this.globalSearch.search.refund },
        };
    }

    paramsChangeHandler = (newParams) => {
        this.getAllItems(newParams);
    };

    getBackLink = () => this.datasource.routes().home;

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        const modifiedFields = {
            ...fields,
            confirmed_without_docs: {
                ...fields.confirmed_without_docs,
                readOnly: true,
            },
            is_partial_refund: {
                ...fields.is_partial_refund,
                readOnly: true,
            }
        };

        const updatedItems = this.state.AllItems.map(item => {
            if (item.status === "Отправлено") {
                return {
                    ...item,
                    notEdit: true
                };
            }
            return item;
        });

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title={"Возвраты денежных средств"}
                        columns={{
                            reservation_id: "Id заявки",
                            order_number: "Номер заказа",
                            amount: "Сумма",
                            status: "Статус",
                            created_at: "Дата создания",
                            guest_name: "Гость",
                            name: "Правило",
                        }}
                        items={updatedItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        editAction={this.getEditLink}
                        removeAction={this.removeItem}
                        updateParticularItem={this.updateParticularItem}
                        defaultSortOrder={
                            this.globalSearch.search.refund.sortOrder
                        }
                        defaultSortfield={
                            this.globalSearch.search.refund.sortField
                        }
                        fields={fields}
                        globalSearch={this.globalSearch}
                        updateGlobalSearch={this.updateGlobalSearch}
                        paramsChangeHandler={this.paramsChangeHandler}
                        thisRefund={true}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        title="Редактировать запрос на возврат"
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={modifiedFields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateItem}
                        submitActionApply={this.updateItemWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relationsDataSource={relationsDataSource}
                        relations={relations}
                        interfaceTypes={this.state.interfaces}
                        thisCancellationPolicy={true}
                    />
                </Route>
            </Switch>
        );
    };
}

export default RefundContainer;

